export interface DataClearedFilterType {
  dataCleared: server.dto.DataClearedFilterSettings
}

export const initialDataClearedFilter: DataClearedFilterType = {
  dataCleared: "noFilter"
};